import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IWhyChoose, IWhyChooseInitialState } from "./whychooseModal";
import {
  ActiveInactiveWhyChoose,
  createWhyChoose,
  deleteWhyChoose,
  WhyChooseImageUpload,
  getAllActiveWhyChoose,
  getAllWhyChoose,
  getWhyChooseByID,
  updateWhyChoose,
} from "./services/whychoose.service";

const initialState: IWhyChooseInitialState = {
  loading: false,
  formLoading: false,
  error: "",
  WhyChooseID: null,
  WhyChooseList: [],
  WhyChooseDetail: {
    ID: null,
    Title: "",
    Description: "",
    Image: "",
    IsActive: 1,
  },
};

const whychooseSlice = createSlice({
  name: "whychoose",
  initialState,
  reducers: {
    clearWhyChooseDetails: (state) => {
      state.WhyChooseDetail = initialState.WhyChooseDetail;
    },
    setWhyChooseID: (state, action) => {
      state.WhyChooseID = action.payload;
    },
    clearWhyChooseID: (state) => {
      state.WhyChooseID = initialState.WhyChooseID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllWhyChoose.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllWhyChoose.fulfilled,
      (state, action: PayloadAction<IWhyChoose[]>) => {
        state.loading = false;
        state.WhyChooseList = action.payload || [];
      },
    );
    builder.addCase(getAllWhyChoose.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.WhyChooseList = [];
    });
    builder.addCase(createWhyChoose.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(createWhyChoose.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createWhyChoose.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateWhyChoose.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updateWhyChoose.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateWhyChoose.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteWhyChoose.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteWhyChoose.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteWhyChoose.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getWhyChooseByID.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(getWhyChooseByID.fulfilled, (state, action: any) => {
      state.formLoading = false;
      state.WhyChooseDetail = action.payload;
    });
    builder.addCase(getWhyChooseByID.rejected, (state, action) => {
      state.formLoading = false;
      state.WhyChooseDetail = initialState.WhyChooseDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActiveWhyChoose.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveWhyChoose.fulfilled,
      (state, action: PayloadAction<IWhyChoose[]>) => {
        state.loading = false;
        state.WhyChooseList = action.payload || [];
      },
    );
    builder.addCase(getAllActiveWhyChoose.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.WhyChooseList = [];
    });
    builder.addCase(ActiveInactiveWhyChoose.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveWhyChoose.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveWhyChoose.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // IMAGE UPLOAD
    builder.addCase(WhyChooseImageUpload.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(WhyChooseImageUpload.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(WhyChooseImageUpload.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearWhyChooseDetails, clearWhyChooseID, setWhyChooseID } =
  whychooseSlice.actions;
export default whychooseSlice.reducer;
